import { Fragment } from "react";

const STAGES = [
  { label: "Erwähnung", dot: "bg-fc-blue", text: "text-fc-blue" },
  { label: "Entwicklung", dot: "bg-fc-coral", text: "text-fc-coral" },
  { label: "Signal", dot: "bg-status-critical", text: "text-status-critical" },
];

/* Dezente Eskalations-Sequenz: Erwähnung -> Entwicklung -> Signal (rein CSS, kein State). */
export function SignalSequence({ className = "" }) {
  return (
    <div className={`flex items-center ${className}`} data-testid="signal-sequence" aria-label="Ablauf: Erwähnung, Entwicklung, Signal">
      {STAGES.map((s, i) => (
        <Fragment key={s.label}>
          <span className="inline-flex items-center gap-1.5 flex-shrink-0">
            <span className="relative flex h-2 w-2">
              {i === 2 && <span className="absolute inline-flex h-full w-full rounded-full bg-status-critical opacity-60 status-pulse" />}
              <span className={`relative inline-flex h-2 w-2 rounded-full ${s.dot}`} />
            </span>
            <span className={`text-[11px] font-semibold ${s.text}`}>{s.label}</span>
          </span>
          {i < STAGES.length - 1 && (
            <svg className="flex-1 mx-1.5 h-3 min-w-[16px] text-fc-ink/25" viewBox="0 0 40 12" preserveAspectRatio="none" aria-hidden="true">
              <line x1="0" y1="6" x2="34" y2="6" stroke="currentColor" strokeWidth="1.4" className="fc-flow" />
              <path d="M34 2.5 L40 6 L34 9.5" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          )}
        </Fragment>
      ))}
    </div>
  );
}

export default SignalSequence;
